import { Field, InputType, ObjectType } from 'type-graphql'
import { ActionArgs, type IAction } from '../../action'
import GraphQLJSON from 'graphql-type-json'
import type { PaymentGatewayObject } from '../PaymentGatewayObject'
import type { PaymentGatewayProvider } from '../PaymentGatewayProviderEnum'

@InputType()
@ObjectType()
export class GetPaymentDetailArgs extends ActionArgs {
  @Field(() => String)
  externalId: string

  @Field(() => String)
  paymentId?: string

  @Field(() => GraphQLJSON)
  retrieveParams?: Record<string, any>

  @Field(() => GraphQLJSON)
  options?: Record<string, any>

  @Field(() => String)
  gatewayProvider?: PaymentGatewayProvider
}

export interface IGetPaymentDetail extends IAction<PaymentGatewayObject, GetPaymentDetailArgs> {}
